// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_handle_sdha6_1v8zk_5:not(#\\9){cursor:grab;touch-action:none}.awsui_handle_sdha6_1v8zk_5:not(#\\9):active{cursor:grabbing}\n", ""]);
// Exports
module.exports = exports;
